import React, {Fragment} from "react";
import  {UncontrolledTooltip}  from "reactstrap";

import tooltip from "../../../public/svg/i.svg";

export const Tooltip = ({ text, height, width, right=null, top=null, backgroundColor=null, borderRadius=null }) => {
    
  const tooltTipStyles = {
    color: "white",
    backgroundColor: "#106eb0",
    fontFamily: "Arial"
  };

  const containerStyles = {
    height: height,
    width: width,
    position: "absolute",
    right: right,
    top: top,
    backgroundColor: backgroundColor,
    fontFamily: "Arial",
    borderRadius: borderRadius
  };

  return (
    <div style={containerStyles}>
      <UncontrolledTooltip placement="right" style={tooltTipStyles} target="tooltip">
        {text}
      </UncontrolledTooltip>
      <img src={tooltip} alt="tooltip" id="tooltip"/>
    </div>
  );
};
